// file to export all the flags tags to be used in the app

export enum FeatureFlagCategory {
  Features = "features",
  DataProviders = "dataProviders",
  AI = "ai",
  Others = "others",
}

export const FEATURE_FLAG_KEYS = {
  [FeatureFlagCategory.Features]: {
    SHOW_LEARN_PAGE: "show-learn-page",
    SHOW_CHICKLETS: "show-chicklets",
    SHOW_SECURITY_PAGE: "show-security-page",
    SHOW_EXPERIMENT_PERIODIC_CHART: "show-experiment-periodic-chart",
    SHOW_DAILY_INTERVAL: "show-daily-interval",
    SHOW_GRAFFY_PAGE: "show-graffy-page",
    SHOW_CUSTOM_LIST: "show-custom-list",
    SHOW_INVITE_BUTTON: "show-invite-button",
  },
  [FeatureFlagCategory.DataProviders]: {
    USE_GLOSSARY_TERMS: "use-glossary-terms",
  },
  [FeatureFlagCategory.AI]: {
    AI_SUMMARIES_VERSION: "ai-summaries-version",
  },
  [FeatureFlagCategory.Others]: {
    SHOW_LOGS: "show-logs",
    SHOW_OPPFINDER: "show-oppfinder",
    SHOW_FLOW_MONITOR: "show-flow-monitor",
    USER_TYPE: "user-type",
  },
}

// create types based on the feature flags structure
type FlagCategoryKeys<T> = {
  [K in keyof T]: string
}

export type FeatureFlagKeys = {
  [K in FeatureFlagCategory]: FlagCategoryKeys<(typeof FEATURE_FLAG_KEYS)[K]>
}

// create a union type of all possible feature flag keys
type FlattenObject<T> =
  T extends object ? { [K in keyof T]: FlattenObject<T[K]> }[keyof T] : T

export type AllFeatureFlagKeys = FlattenObject<typeof FEATURE_FLAG_KEYS>

// define possible types for feature values
export type FeatureValue = boolean | string | number | object | null | undefined

// define user types for now
export type UserType =
  | "calamos"
  | "allspring"
  | "grafiniti"
  | "weitz"
  | "westwood"
  | "default"
